import { financesStore } from '@/store/finances';
import { BillsAndPaymentsSearchType, BillType } from '@/models/etc/types';
import { BillsAndPaymentsSearchAsker } from '@/models/interfaces/finances/finance-models';
import { BillRowProps } from '@/store/heartbeat-workers/useEntityStore';
import type { StrategyContext } from './types';

/**
 * Factory that creates a `loadMore` function for bill-related strategies.
 * Replaces three near-identical methods: loadMoreBills, loadMoreBillsForExistingMovement, loadMoreBillsForProject.
 */
export function makeBillLoader(
  searchFrom: BillsAndPaymentsSearchType,
  options?: {
    requireType?: BillType;
    getSearchFromId?: (ctx: StrategyContext) => number | undefined;
  },
) {
  return async (
    filter: string,
    count: number,
    offset: number,
    ctx: StrategyContext,
  ): Promise<any[]> => {
    const store = financesStore();
    const bills = await store.movementGetBillsForCreation({
      Filter: filter,
      RequiredType: options?.requireType,
      SearchFrom: searchFrom,
      SearchFromId: options?.getSearchFromId?.(ctx),
      IncludePayments: true,
      Count: count,
      Offset: offset,
    } as BillsAndPaymentsSearchAsker);

    return bills.map((el) => ({
      bill: el,
      Id: el.Id,
      isPreloaded: false,
      billRowType: BillRowProps.BillSearchedBase,
    }));
  };
}
